import { render, staticRenderFns } from "./ConsumerDetails.vue?vue&type=template&id=9c313c6e&scoped=true"
import script from "./ConsumerDetails.vue?vue&type=script&lang=js"
export * from "./ConsumerDetails.vue?vue&type=script&lang=js"
import style0 from "./ConsumerDetails.vue?vue&type=style&index=0&id=9c313c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c313c6e",
  null
  
)

export default component.exports